import React, { useState } from 'react';
import { MenuItem, Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Icon } from '../index';
import { NestedMenuItemProps } from './types';
import { SubMenu } from './SubMenu';

export const NestedMenuItem: React.FC<NestedMenuItemProps> = ({ label, leftIcon, children, ...menuItemProps }) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const [isSubMenuOpen, setIsSubMenuOpen] = useState(false);

  const handleMouseEnter = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
    setIsSubMenuOpen(true);
  };

  const handleMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
    const submenuElement = document.querySelector('.submenu-paper');
    const relatedTarget = event.relatedTarget as HTMLElement;

    // If there's no related target or submenu element, close the submenu
    if (!relatedTarget || !submenuElement) {
      setIsSubMenuOpen(false);
      return;
    }

    // Check if we're moving to the submenu
    try {
      if (!submenuElement.contains(relatedTarget)) {
        setIsSubMenuOpen(false);
      }
    } catch (e) {
      // If contains check fails, close the submenu
      setIsSubMenuOpen(false);
    }
  };

  const handleSubMenuMouseLeave = (event: React.MouseEvent<HTMLElement>) => {
    const menuItemElement = anchorEl;
    const relatedTarget = event.relatedTarget as HTMLElement;

    if (!menuItemElement?.contains(relatedTarget)) {
      setIsSubMenuOpen(false);
    }
  };

  return (
    <>
      <MenuItem
        {...menuItemProps}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}
        sx={{
          display: 'flex',
          alignItems: 'center',
          ...menuItemProps.sx
        }}
      >
        {leftIcon && (
          <Box component="span" sx={{ display: 'flex', mr: 1 }}>
            <Icon size="14" fill="none" name={leftIcon} />
          </Box>
        )}
        <Typography>{label}</Typography>
        <Box component="span" sx={{ display: 'flex', flexGrow: 1, justifyContent: 'flex-end', mr: 1 }}>
          <Icon size="14" fill="none" name="arrow-right-3-outline" />
        </Box>
      </MenuItem>
      <SubMenu open={isSubMenuOpen} anchorEl={anchorEl} onClose={() => setIsSubMenuOpen(false)}>
        <Box className="submenu-paper" onMouseLeave={handleSubMenuMouseLeave}>
          {children}
        </Box>
      </SubMenu>
    </>
  );
};
